import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'phoneNumber'
})
export class PhoneNumberPipe implements PipeTransform {

  transform(phoneNumber: string): string {
    if (phoneNumber.startsWith('46')) {
      return '0' + phoneNumber.slice(2);
    }
    else if (phoneNumber.startsWith('0') || phoneNumber.startsWith('+')) {
      return phoneNumber;
    }
    else {
      return '+' + phoneNumber;
    }
  }

}
